import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms'

import { Observable } from 'rxjs'

import { CommonModule, NgIf } from '@angular/common'
import { UntypedFormControl } from '@angular/forms'
import { KENDO_BUTTONS } from '@progress/kendo-angular-buttons'
import { KENDO_DIALOGS, WindowRef } from '@progress/kendo-angular-dialog'
import { KENDO_DROPDOWNS } from '@progress/kendo-angular-dropdowns'
import { CheckboxColumnComponent, ColumnComponent, GridComponent, GridDataResult, HeaderTemplateDirective, KENDO_GRID, KENDO_GRID_EXCEL_EXPORT, KENDO_GRID_PDF_EXPORT, RowClassArgs, SelectAllCheckboxDirective, SelectAllCheckboxState, SelectionDirective } from '@progress/kendo-angular-grid'
import { KENDO_INDICATORS } from '@progress/kendo-angular-indicators'
import { KENDO_INPUTS } from '@progress/kendo-angular-inputs'
import { PHONE_MASK, toPhoneDigits } from '../../../@theme/pipes/phone.pipe'
import { LabelDirective } from '@progress/kendo-angular-label'
import { State } from '@progress/kendo-data-query'
import { ToastrService } from 'ngx-toastr'
import { NgxValidationMessageComponent } from '../../../@components/validation-message/validation-message.component'
import { UserService } from '../../../@theme/services/user.service'
import { EMAIL_PATTERN } from '../../../auth/constants'

@Component({
  selector: 'gd--edituser',
  templateUrl: './edituser.component.html',
  styleUrls: ['./edituser.component.scss'],
  providers: [WindowRef],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgIf,
    LabelDirective,
    NgxValidationMessageComponent,
    KENDO_DROPDOWNS,
    KENDO_GRID,
    KENDO_INPUTS,
    KENDO_GRID_PDF_EXPORT,
    KENDO_GRID_EXCEL_EXPORT,
    KENDO_INDICATORS,
    KENDO_DIALOGS, KENDO_BUTTONS,
    GridComponent,
    SelectionDirective,
    CheckboxColumnComponent,
    HeaderTemplateDirective,
    SelectAllCheckboxDirective,
    ColumnComponent,
  ]
})
export class EdituserComponent implements OnInit {
  public phoneMask = PHONE_MASK
  toggleFormControl = new UntypedFormControl()
  @Input() userout: any
  @Input() getrolelist: any[]
  @Input() productTypelist: any[]
  @Input() emailTypelist: any[]
  @Output() updateuser: EventEmitter<any> = new EventEmitter()
  public mySelection: number[] = []
  public mySelectionemailTypes: number[] = []
  public mySelectionRoleTypes: string[] = []
  public items: any[]
  public selectAllState: SelectAllCheckboxState = 'unchecked'
  public selectAllStateEmailtype: SelectAllCheckboxState = 'unchecked'
  public selectAllStateRoletype: SelectAllCheckboxState = 'unchecked'
  public repReadOnly = false
  userForm: UntypedFormGroup
  filter: any[]
  getFailedcount: boolean
  buttonActive: string
  buttonText: string
  twofactorstatus: string
  twofactortext: string
  rolesInUse: any
  resettwofactor: string
  resettwofactorstatus: string
  userlist: any
  public lock: boolean
  get id() {
    return this.userForm.get('id')
  }
  get firstName() {
    return this.userForm.get('firstName')
  }
  get lastName() {
    return this.userForm.get('lastName')
  }
  get email() {
    return this.userForm.get('email')
  }
  get userName() {
    return this.userForm.get('userName')
  }
  get phoneNumber() {
    return this.userForm.get('phoneNumber')
  }
  get lockoutEnabled() {
    return this.userForm.get('lockoutEnabled')
  }
  get isApprove() {
    return this.userForm.get('isApprove')
  }
  get twoFactorEnabled() {
    return this.userForm.get('twoFactorEnabled')
  }
  get LockoutEndDateUtc() {
    return this.userForm.get('LockoutEndDateUtc')
  }
  get googleAuthenticatorSecretKey() {
    return this.userForm.get('googleAuthenticatorSecretKey')
  }
  public bindingType = 'array'
  public view: Observable<GridDataResult>
  public gridData: any
  public emailIdList: any[]
  public state: State = {
    skip: 0,
    take: 5,
  }
  constructor(
    private fb: UntypedFormBuilder,
    private ur: UserService,
    private toastrService: ToastrService,
  ) { }
  ngOnInit() {
    this.items = this.productTypelist
    this.initUserForm()
  }
  initUserForm() {
    this.userForm = this.fb.group({
      id: this.fb.control(''),
      isApprove: this.fb.control(''),
      firstName: this.fb.control('', [
        Validators.minLength(3),
        Validators.maxLength(20),
      ]),
      lastName: this.fb.control('', [
        Validators.minLength(3),
        Validators.maxLength(20),
      ]),
      phoneNumber: this.fb.control('', [
        Validators.minLength(3),
        Validators.maxLength(20),
      ]),
      email: this.fb.control('', [
        Validators.required,
        Validators.pattern(EMAIL_PATTERN),
      ]),
      userName: this.fb.control(''),
      lockoutEnabled: this.fb.control(''),
      twoFactorEnabled: this.fb.control(''),
      googleAuthenticatorSecretKey: this.fb.control(''),
    })
    this.loadUser()
  }

  public onSelectedKeysChangeRoles(e: any) {
    this.mySelectionRoleTypes = e;
    const len = this.mySelectionRoleTypes.length
    if (len === 0) {
      this.selectAllStateRoletype = 'unchecked'
    } else if (len > 0 && len < this.getrolelist?.length) {
      this.selectAllStateRoletype = 'indeterminate'
    } else {
      this.selectAllStateRoletype = 'checked'
    }
    this.updateRepReadOnly()
  }

  private updateRepReadOnly() {
    const repRole = this.getrolelist?.find(
      (role) => (role?.name || '').trim().toLowerCase() === 'rep'
    )
    this.repReadOnly =
      !!repRole && (this.mySelectionRoleTypes || []).includes(repRole.id)
  }

  public rowClassRoles = (context: RowClassArgs): string => {
    const name = (context.dataItem?.name || '').trim().toLowerCase()
    return this.repReadOnly && name !== 'rep' ? 'role-disabled' : ''
  }

  public onSelectedKeysChangeProducts(e: any) {
    this.mySelection = e;
  }

  public onSelectedKeysChangeEmails(e: any) {
    this.mySelectionemailTypes = e;
  }
  Toggle2Factor() {
    const twofactor = this.userForm.controls['twoFactorEnabled'].value
    if (twofactor === false) {
      this.twofactortext = '2 Factor Enabled'
      this.twofactorstatus = 'success'
      this.userForm.setValue({
        id: this.userout.id,
        firstName: this.userout.firstName ? this.userout.firstName : '',
        lastName: this.userout.lastName ? this.userout.lastName : '',
        email: this.userout.email,
        userName: this.userout.userName,
        phoneNumber: toPhoneDigits(this.userout.phoneNumber.replace('+1', '')),
        lockoutEnabled: this.userout.lockoutEnabled
          ? this.userout.lockoutEnabled
          : false,
        twoFactorEnabled: true,
        isApprove: this.userout.isApprove ? this.userout.isApprove : false,
        googleAuthenticatorSecretKey: this.userout.googleAuthenticatorSecretKey
          ? this.userout.googleAuthenticatorSecretKey
          : null,
      })
      return
    }
    if (twofactor === true) {
      this.twofactortext = '2 Factor Disabled'
      this.twofactorstatus = 'danger'
      this.userForm.setValue({
        id: this.userout.id,
        firstName: this.userout.firstName ? this.userout.firstName : '',
        lastName: this.userout.lastName ? this.userout.lastName : '',
        email: this.userout.email,
        userName: this.userout.userName,
        phoneNumber: toPhoneDigits(this.userout.phoneNumber.replace('+1', '')),
        lockoutEnabled: this.userout.lockoutEnabled
          ? this.userout.lockoutEnabled
          : false,
        twoFactorEnabled: false,
        isApprove: this.userout.isApprove ? this.userout.isApprove : false,
        googleAuthenticatorSecretKey: this.userout.googleAuthenticatorSecretKey
          ? this.userout.googleAuthenticatorSecretKey
          : null,
      })
      return
    }
  }
  Toggleqrcode() {
    const qrCode = this.userForm.controls['googleAuthenticatorSecretKey'].value
    if (qrCode !== null) {
      this.resettwofactor = 'qrcode reset'
      this.resettwofactorstatus = 'warning'
      this.userForm.setValue({
        id: this.userout.id,
        firstName: this.userout.firstName ? this.userout.firstName : '',
        lastName: this.userout.lastName ? this.userout.lastName : '',
        email: this.userout.email,
        userName: this.userout.userName,
        phoneNumber: toPhoneDigits(this.userout.phoneNumber.replace('+1', '')),
        lockoutEnabled: this.userout.lockoutEnabled
          ? this.userout.lockoutEnabled
          : false,
        twoFactorEnabled: this.userout.twoFactorEnabled
          ? this.userout.twoFactorEnabled
          : false,
        isApprove: this.userout.isApprove ? this.userout.isApprove : false,
        googleAuthenticatorSecretKey: null,
      })
      return
    }
    if (qrCode === null) {
      this.resettwofactor = 'qrcode set'
      this.resettwofactorstatus = 'success'
      this.userForm.setValue({
        id: this.userout.id,
        firstName: this.userout.firstName ? this.userout.firstName : '',
        lastName: this.userout.lastName ? this.userout.lastName : '',
        email: this.userout.email,
        userName: this.userout.userName,
        phoneNumber: toPhoneDigits(this.userout.phoneNumber.replace('+1', '')),
        lockoutEnabled: this.userout.lockoutEnabled
          ? this.userout.lockoutEnabled
          : false,
        twoFactorEnabled: this.userout.twoFactorEnabled
          ? this.userout.twoFactorEnabled
          : false,
        isApprove: this.userout.isApprove ? this.userout.isApprove : false,
        googleAuthenticatorSecretKey: 'data',
      })
      return
    }
  }
  toggleapprove() {
    const appove = this.userForm.controls['isApprove'].value
    if (appove === true) {
      this.buttonActive = 'danger'
      this.buttonText = 'InActive'
    }
    if (appove === false) {
      this.buttonActive = 'success'
      this.buttonText = 'Active'
    }
  }
  checkStatusValue() {
    this.getFailedcount = this.userout.isApprove
    const get2FactorStatus = this.userout.twoFactorEnabled
    const googleAuthenticatorSecretKey =
      this.userout.googleAuthenticatorSecretKey
    if (this.getFailedcount === false) {
      this.buttonActive = 'danger'
      this.buttonText = 'InActive'
    }
    if (this.getFailedcount === true) {
      this.buttonActive = 'success'
      this.buttonText = 'Active'
    }
    if (get2FactorStatus === true) {
      this.twofactortext = '2 Factor Enabled'
      this.twofactorstatus = 'success'
    }
    if (get2FactorStatus === false) {
      this.twofactortext = '2 Factor Disabled'
      this.twofactorstatus = 'danger'
    }
    if (googleAuthenticatorSecretKey === null) {
      this.resettwofactor = 'qrcode reset'
      this.resettwofactorstatus = 'warning'
    }
    if (googleAuthenticatorSecretKey !== null) {
      this.resettwofactor = 'qrcode set'
      this.resettwofactorstatus = 'success'
    }
  }
  loadUser() {
    this.checkStatusValue()
    this.getRolesbyUserId(this.userout.id)
    this.getEmailbyProductTypeId(this.userout.id)
    this.userForm.setValue({
      id: this.userout.id,
      firstName: this.userout.firstName ? this.userout.firstName : '',
      lastName: this.userout.lastName ? this.userout.lastName : '',
      email: this.userout.email,
      userName: this.userout.userName,
      phoneNumber: toPhoneDigits(this.userout.phoneNumber.replace('+1', '')),
      lockoutEnabled: this.userout.lockoutEnabled
        ? this.userout.lockoutEnabled
        : false,
      twoFactorEnabled: this.userout.twoFactorEnabled
        ? this.userout.twoFactorEnabled
        : false,
      isApprove: this.userout.isApprove ? this.userout.isApprove : false,
      googleAuthenticatorSecretKey: this.userout.googleAuthenticatorSecretKey
        ? this.userout.googleAuthenticatorSecretKey
        : null,
    })
  }
  getRolesbyUserId(Id: string) {
    this.ur.getRolebyUserId(Id).subscribe((r) => {
      this.mySelectionRoleTypes = r
      this.updateRepReadOnly()
    })
  }
  getEmailbyProductTypeId(Id: string) {
    this.ur.getUserIdbyProductTypeId(Id).subscribe((r) => {
      const prodtype = r.map(function (p: any) {
        return p.productType
      })
      const emailtype = r.map(function (e: any) {
        return e.emailTypeId
      })
      const emailId = r.map(function (e: any) {
        return e.emailId
      })
      this.mySelection = prodtype
      this.mySelectionemailTypes = emailtype
      this.emailIdList = emailId
    })
  }
  getEmailbyTypeId(Id: string) {
    this.ur.getUserIdbyProductTypeId(Id).subscribe((r) => {
      this.mySelection = r
    })
  }

  public onSelectAllChange(checkedState: SelectAllCheckboxState): void {
    if (checkedState === 'checked') {
      this.mySelectionRoleTypes = this.items
        .map((item) => item.ProductID)
        .filter((id) => id % 2 == 0);
      this.selectAllState = 'checked';
    } else {
      this.mySelectionRoleTypes = [];
      this.selectAllState = 'unchecked';
    }
  }
  onSubmit() {
    // Map role IDs to role objects with names
    const roleData = this.mySelectionRoleTypes.map(id => {
      const role = this.getrolelist.find(r => r.id === id);
      return role ? { Name: role.id } : null;
    }).filter(role => role !== null);  // Filter out any null values

    // Map product type selections
    const prodtypelist = this.mySelection.map((obj) => ({ productTypeId: obj }))
    
    // Map email type selections
    const emailUserL = this.mySelectionemailTypes.map((obj) => ({
      emailTypeId: obj,
    }))
    
    // Map email IDs (if available)
    const emailUser = this.emailIdList ? this.emailIdList.map((obj) => ({ emailId: obj })) : []

    // Debug logging
/*     console.log('Role selections:', this.mySelectionRoleTypes);
    console.log('Product type selections:', this.mySelection);
    console.log('Email type selections:', this.mySelectionemailTypes);
    console.log('Role data mapped:', roleData);
    console.log('Product type list:', prodtypelist);
    console.log('Email user list:', emailUserL); */

    const param = {
      userlist: {
        role: roleData, // Use the correctly mapped role data
        Userlist: this.userForm.value,
        Producttyplist: prodtypelist,
        Emailuser: emailUser,
        EmailTypes: emailUserL,
      },
    }

    //console.log('Final param object:', JSON.stringify(param, null, 2));

    this.ur.SaveprofileusersInfo(param).subscribe((r) => {
      this.showToast(
        'success',
        'You are currently being redirected to User List.',
      )
      setTimeout(() => this.updateuser.emit(), 3000)
    })
  }
  showToast(status: 'success' | 'error' | 'info' | 'warning', message: string) {
    switch (status) {
      case 'success':
        this.toastrService.success(message, 'Success');
        break;
      case 'error':
        this.toastrService.error(message, 'Error');
        break;
      case 'info':
        this.toastrService.info(message, 'Info');
        break;
      case 'warning':
        this.toastrService.warning(message, 'Warning');
        break;
      default:
        this.toastrService.show(message);
        break;
    }
  }
}
